import {
  DistributeCenter,
  DistributeCenterSmall,
  DistributeFullWidth,
  DistributeFullWidthSmall,
  DistributeVertically,
  DistributeVerticallySmall,
  SizeAndRatio,
  SizeAndRatioSmall
} from "@wix/wix-ui-icons-common";
import {
  SIZE_DROPDOWN_OPTION_CONTENT,
  SIZE_DROPDOWN_OPTION_FULL_WIDTH,
  SIZE_DROPDOWN_OPTION_ORIGINAL,
  SIZE_DROPDOWN_OPTION_SMALL
} from "./../data-hooks.js";
const NODE_SIZE_BUTTONS = {
  CONTENT: {
    text: "SizeContentButton_Tooltip",
    tooltip: "SizeContentButton_Tooltip",
    commandKey: "CONTENT",
    icon: DistributeVertically,
    iconSmall: DistributeVerticallySmall,
    dataHook: SIZE_DROPDOWN_OPTION_CONTENT
  },
  SMALL: {
    text: "SizeSmallCenterButton_Tooltip",
    commandKey: "SMALL",
    icon: DistributeCenter,
    iconSmall: DistributeCenterSmall,
    dataHook: SIZE_DROPDOWN_OPTION_SMALL
  },
  ORIGINAL: {
    text: "SizeOriginalButton_Tooltip",
    commandKey: "ORIGINAL",
    icon: SizeAndRatio,
    iconSmall: SizeAndRatioSmall,
    dataHook: SIZE_DROPDOWN_OPTION_ORIGINAL
  },
  FULL_WIDTH: {
    text: "SizeFullWidthButton_Tooltip",
    commandKey: "FULL_WIDTH",
    icon: DistributeFullWidth,
    iconSmall: DistributeFullWidthSmall,
    dataHook: SIZE_DROPDOWN_OPTION_FULL_WIDTH
  }
};
const DEFAULT_OPTIONS = ["SMALL", "CONTENT", "FULL_WIDTH"];
export {
  DEFAULT_OPTIONS,
  NODE_SIZE_BUTTONS
};
//# sourceMappingURL=consts.js.map
